"use strict";
/*
 * Created on 16. 9. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var ShelfReportRowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ShelfReportRowConverter, _DataObjectConverter_);

  function ShelfReportRowConverter() {
    _classCallCheck(this, ShelfReportRowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShelfReportRowConverter).apply(this, arguments));
  }

  return ShelfReportRowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ShelfReportRowConverter = ShelfReportRowConverter;